const authenticationResultKey = 'api-authentication-result';

export const storeAuthenticationResult = (result: string): void => {
    sessionStorage.setItem(authenticationResultKey, result);
};

export const retrieveAuthenticationResult = (): string | null => {
    return sessionStorage.getItem(authenticationResultKey) || null;
};